import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'

import './assets/scss/style.scss'
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'
import 'vue-material/dist/theme/black-green-light.css'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-TW'
import '../theme/index.css'

import datePicker from 'vue-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vuescroll from 'vuescroll/dist/vuescroll-native'
// import the css file
import 'vuescroll/dist/vuescroll.css'
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(vuescroll)
// import _$ from 'jquery'
// var $ = _$
// window.$ = $
Vue.use(VueMaterial)
Vue.use(datePicker)
Vue.use(ElementUI, { locale })

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
